module.exports = __webpack_public_path__ + "static/media/4931-06.6fde37fe.png";